import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["tagName", "className", "leftSide", "rightSide", "title", "subTitle", "disabled", "offset", "reverse", "size", "form", "view"];
import { cnBem, forwardRefWithTag } from '@carnica/utils';
import React from 'react';
import styles from "./styles.pcss";
import { isSideRenderable, isSideText } from "./utils";
import { CellSide } from "./CellSide";
import { CellText } from "./CellText";
export var cnCell = cnBem('cell', styles);
export var Cell = forwardRefWithTag(function (props, ref) {
  var _props$tagName = props.tagName,
    tagName = _props$tagName === void 0 ? 'div' : _props$tagName,
    className = props.className,
    leftSide = props.leftSide,
    rightSide = props.rightSide,
    title = props.title,
    subTitle = props.subTitle,
    disabled = props.disabled,
    _props$offset = props.offset,
    offset = _props$offset === void 0 ? 'l' : _props$offset,
    reverse = props.reverse,
    _props$size = props.size,
    size = _props$size === void 0 ? 's' : _props$size,
    _props$form = props.form,
    form = _props$form === void 0 ? 'default' : _props$form,
    _props$view = props.view,
    view = _props$view === void 0 ? 'default' : _props$view,
    otherProps = _objectWithoutProperties(props, _excluded);
  var Tag = tagName;
  var additionalProps = tagName === 'button' ? {
    disabled: disabled
  } : {};
  var isRightSideText = isSideText(rightSide);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    className: cnCell({
      view: view,
      disabled: disabled,
      form: form,
      offset: offset
    }, [className]),
    ref: ref
  }, otherProps, additionalProps, {
    "data-t-id": "components-Cell"
  }), isSideRenderable(leftSide, disabled) && /*#__PURE__*/React.createElement("div", {
    className: cnCell('slot', {
      side: 'left'
    })
  }, /*#__PURE__*/React.createElement(CellSide, {
    disabled: disabled,
    position: "left",
    side: leftSide
  })), /*#__PURE__*/React.createElement("div", {
    className: cnCell('slot', {
      side: 'center',
      reverse: reverse
    })
  }, /*#__PURE__*/React.createElement(CellText, {
    disabled: disabled,
    label: title,
    size: size,
    type: "title"
  }), /*#__PURE__*/React.createElement(CellText, {
    disabled: disabled,
    label: subTitle,
    type: "subtitle"
  })), isSideRenderable(rightSide, disabled) && /*#__PURE__*/React.createElement("div", {
    className: cnCell('slot', {
      side: 'right',
      isText: isRightSideText
    })
  }, /*#__PURE__*/React.createElement(CellSide, {
    disabled: disabled,
    position: "right",
    side: rightSide
  })));
});